/** Quick-selection surfaces omit inactive and archived organisations. */
export function isSelectableTenant(tenant: { is_active?: boolean; archived_at?: string | null }): boolean {
  return tenant.is_active !== false && !tenant.archived_at
}
